var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-fill bg-f3f"},[_c('Header'),_c('common-item',{attrs:{"list":_vm.indexDataTopList}}),_c('study-program'),_c('common-item',{attrs:{"list":_vm.indexDataBottomList}}),_c('down-load-version'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }